document.addEventListener('DOMContentLoaded', function () {
    const dismissedKey = "en-redirect-dismissed";

    if (location.hostname.startsWith("www.")) {
        return;
    }

    const botPattern = /googlebot|bingbot|yandex|baiduspider|duckduckbot|slurp|facebookexternalhit|twitterbot/i;
    if (botPattern.test(navigator.userAgent)) {
        return;
    }

    if (localStorage.getItem(dismissedKey) === "true") {
        return;
    }

    const browserLanguage = (navigator.language || navigator.languages?.[0] || "").toLowerCase();
    if (browserLanguage.startsWith("de")) {
        return;
    }

    const targetUrl = "https://www.rasotec.com" + location.pathname + location.search;

    const overlay = document.createElement("div");
    overlay.className = "popup-overlay displayflex";
    overlay.id = "deRedirectOverlay";

    const popup = document.createElement("div");
    popup.className = "popup";
    popup.innerHTML = `
        <h2>English version available</h2>
        <p>It looks like you prefer English. Would you like to switch to the English version of rasotec?</p>
    `;

    const switchButton = document.createElement("div");
    switchButton.className = "button";
    switchButton.id = "deRedirectSwitch";
    switchButton.innerHTML = "<p><a>Go to the English site</a></p>";

    const stayButton = document.createElement("div");
    stayButton.className = "button";
    stayButton.id = "deRedirectStay";
    stayButton.innerHTML = "<p><a>Stay in German</a></p>";

    switchButton.addEventListener("click", () => {
        localStorage.setItem(dismissedKey, "false");
        location.href = targetUrl;
    });

    stayButton.addEventListener("click", () => {
        localStorage.setItem(dismissedKey, "true");
        overlay.remove();
        document.body.style.overflow = "";
    });

    popup.appendChild(switchButton);
    popup.appendChild(stayButton);
    overlay.appendChild(popup);
    document.body.appendChild(overlay);
    document.body.style.overflow = "hidden";
});
